import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppConcept from './AppConcept';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// Toggle between normal and concept version
const SHOW_CONCEPT = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {SHOW_CONCEPT ? <AppConcept /> : <App />}
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
